import 'slick-carousel';

$(document).ready(() => {
	const slider = $('.item__slider');

	$(document).on('click', '.slider-arrows, .slick-dots, .item__instant-preview', function(event) {
		event.preventDefault();
	});

	slider.slick({
		speed: 300,
		dots: true,
		arrows: true,
		fade: true,
		prevArrow: `<svg class="slider-arrows previous-arrow" width="20" height="34" viewBox="0 0 20 34" fill="none" xmlns="http://www.w3.org/2000/svg">
								<g>
								<path fill-rule="evenodd" clip-rule="evenodd" d="M19.1438 29.5632C20.1646 30.5733 20.1614 32.2234 19.1366 33.2295C18.1354 34.2125 16.5313 34.2125 15.53 33.2295L1.18034 19.1407C-0.0173058 17.9648 -0.0173037 16.0352 1.18034 14.8593L15.53 0.770504C16.5313 -0.212529 18.1354 -0.212528 19.1366 0.770504C20.1614 1.77661 20.1646 3.42667 19.1438 4.43679L8.60288 14.8676C7.41641 16.0416 7.4164 17.9584 8.60287 19.1324L19.1438 29.5632Z" fill="white" fill-opacity="0.6"/>
								</g>
								<defs>
								<filter id="filter0_b" x="-19.718" y="-19.9668" width="59.6252" height="73.9335" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
								<feFlood flood-opacity="0" result="BackgroundImageFix"/>
								<feGaussianBlur in="BackgroundImage" stdDeviation="10"/>
								<feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur"/>
								<feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur" result="shape"/>
								</filter>
								</defs>
								</svg>`,
		nextArrow: `<svg class="slider-arrows next-arrow" width="20" height="34" viewBox="0 0 20 34" fill="none" xmlns="http://www.w3.org/2000/svg">
								<g>
								<path fill-rule="evenodd" clip-rule="evenodd" d="M0.856189 4.43679C-0.164594 3.42667 -0.16136 1.77661 0.863376 0.770503C1.86461 -0.212529 3.46872 -0.21253 4.46996 0.770503L18.8197 14.8593C20.0173 16.0352 20.0173 17.9648 18.8197 19.1407L4.46996 33.2295C3.46872 34.2125 1.86461 34.2125 0.863376 33.2295C-0.161361 32.2234 -0.164596 30.5733 0.856188 29.5632L11.3971 19.1324C12.5836 17.9584 12.5836 16.0416 11.3971 14.8676L0.856189 4.43679Z" fill="white" fill-opacity="0.6"/>
								</g>
								<defs>
								<filter id="filter0_b" x="-19.9072" y="-19.9668" width="59.6252" height="73.9335" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
								<feFlood flood-opacity="0" result="BackgroundImageFix"/>
								<feGaussianBlur in="BackgroundImage" stdDeviation="10"/>
								<feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur"/>
								<feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur" result="shape"/>
								</filter>
								</defs>
								</svg>`,
	});
});
